// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2651M","content":"LoadingAlert_content__23esE"};